'use es6';

import { Alert } from 'foundations-components/transitional/components/Alert';
import { H4 } from 'foundations-components/transitional/components/H4';
import { HelpLink } from 'foundations-components/transitional/components/HelpLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const handleOpenChange = evt => {
  if (evt.target.value) {
    UsageTracker.trackEditorInteraction({
      action: 'Approvals Action',
      event: 'viewContentEditorAccessRequestTooltip'
    });
  }
};
const WillUnpublishSoonWarning = ({
  langKey
}) => /*#__PURE__*/_jsxs(Alert, {
  type: "warning",
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: `willUnpublishSoonWarning.${langKey}.title`
  }), /*#__PURE__*/_jsx(HelpLink, {
    defaultOpen: false,
    showCloseButton: true,
    onOpenChange: evt => handleOpenChange(evt),
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "willUnpublishSoonWarning.helpPopoverHeader"
        })
      }),
      body: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `willUnpublishSoonWarning.${langKey}.helpPopoverBody`
        })
      })
    },
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `willUnpublishSoonWarning.${langKey}.helpPopoverLink`
    })
  })]
});
export default WillUnpublishSoonWarning;